import jsPDF from "jspdf";
import "jspdf-autotable";
import { getFullCourseName } from "./course";

export const printPdf = (
  students,
  courseName,
  module,
  allStudents,
  feeStatus
) => {
  const doc = new jsPDF();
  const moduleNo = module === 1 ? 0 : module === 2 ? 1 : 2;

  // Status table at the top
  doc.text(
    `Course Name: ${courseName.name} (${courseName.type}) Module: ${module} `,
    14,
    10
  );
  const statusColumn = ["Status", "Count"];
  let statusRows = []
  if (allStudents) {
    statusRows = [
      ["Pending", feeStatus.pending],
      ["Rejected", feeStatus.rejected],
      ["Total with Screenshot", feeStatus.totalWithScreenshot],
      ["Unpaid", feeStatus.unpaid],
      ["Verified", feeStatus.verified],
      ["Total", feeStatus.total],
      ["Total Amount", feeStatus.totalAmount]
    ];
  } else {
    statusRows = [
      ["Total Verified", feeStatus.verified],
      ["Total Students", feeStatus.total],
      ["Total Amount", feeStatus.totalAmount],
    ];
  }


  doc.autoTable(statusColumn, statusRows, {
    startY: 15,
    margin: { top: 15 },
    styles: { fontSize: 10 },
    columnStyles: {
      1: { halign: "left" },
    }
  });


  const tableColumn = ["Student Id", "Email", "FullName", "Fee Amount", "Fee Status"];
  const tableRows = [];

  students.forEach((student) => {
    const feeScreenShot = student.courses[student.courseIndex].feeScreenshots[moduleNo];
    if (feeScreenShot && !allStudents) {
      const studentData = [
        student.studentId,
        student.email,
        student.fullName,
        feeScreenShot?.feeAmount,
        feeScreenShot.status,
      ];
      if (feeScreenShot?.status === "verified") tableRows.push(studentData);
    } else if (allStudents) {
      const studentData = [
        student.studentId,
        student.email,
        student.fullName,
        feeScreenShot?.feeAmount,
        feeScreenShot?.status,
      ];
      tableRows.push(studentData);
    }
  });

  doc.autoTable(tableColumn, tableRows, {
    startY: allStudents ? 90 : 60,
    margin: { top: 20 },
    styles: { fontSize: 10 },
    columnStyles: {
      3: { halign: "left" },
    },
    
  });

  const dateString = new Date().toLocaleDateString("en-GB", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  }).replace(/\//g, "");

  const fileName = `${courseName.name}_Module${module}_${dateString}.pdf`;
  doc.save(fileName);
};

export const printResultPdf = (
  students,
  quizCategory,
  activeCourse
) => {
  const doc = new jsPDF();

  // Status table at the top
  doc.text(
    `Quiz Name: ${quizCategory.main} (${quizCategory.sub}) `,
    14,
    10
  );

  const tableColumn = ["S.No", "Name", "Marks", "Batch",];
  const tableRows = [];

  students.forEach((student, index) => {
    tableRows.push([
      index + 1,
      student.fullName,
      student.result[student.resultIndex].marks.toFixed(),
      getFullCourseName(activeCourse),
    ])
  });

  console.log('tableRows', tableRows)
  doc.autoTable(tableColumn, tableRows, {
    startY: 60,
    margin: { top: 20 },
    styles: { fontSize: 10 },
    columnStyles: {
      3: { halign: "left" },
    },

  });
  const fileName = `Result.pdf`;
  doc.save(fileName);
};
